import{jsx as t}from"react/jsx-runtime";import{FontIcon as o}from"@fluentui/react";const r=({styles:r,...e})=>t(o,{...e,style:r?.root});export{r as FontIcon};
//# sourceMappingURL=FontIcon.js.map
